module.exports = __webpack_public_path__ + "static/pic_videoStudent-fc4195c398b7a9569f58bbdfa5e12f6e.jpg";